export default {
  // 收貨信息標籤
  recipientName: "收貨人姓名",
  contactPhone: "聯繫手機",
  deliveryAddress: "收貨地址",
  quantity: "數量",
  time: "時間",
};
